import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AlertController, ModalController} from '@ionic/angular';
import {Shop} from "../../models/shop";
import {WorkingPeriod} from "../../models/submodels/timetable";
import {ShopService} from "../../services/shop.service";

@Component({
  selector: 'set-work-period',
  templateUrl: 'set-work-period.html',
    styleUrls: ['set-work-period.scss']
})

export class SetWorkPeriodComponent {

  period: string;
  interval: string;
  begin: string;
  end: string;
  pickedTimeBegin: string;
  pickedTimeEnd: string;
  timeError: string;
  errorMessage: string;
  restaurant: Shop;
  timetable: WorkingPeriod[];
  maxTime: string;
  minTime: string;
  disableBegin: boolean;
  disableEnd: boolean;
  disableDinner: boolean;

  constructor(private viewCtrl: ModalController,
              private alertCtlr: AlertController,
              private ts: TranslateService,
              private shopService: ShopService) {

      this.pickedTimeBegin = '';
      this.pickedTimeEnd = '';
      this.timeError = 'valid';
      this.errorMessage = '';
      this.timetable = [];
      // this.restaurant = EatmaticStoreService.getRestaurant();

      // this.timetable = JSON.parse(JSON.stringify(this.restaurant.timetable));
      // let time = this.setOneMinutePlus(this.restaurantService.getWorkingPeriod(this.timetable, 'lunch').end);
      // this.restaurantService.setWorkingPeriod(this.timetable, 'lunch', null, time);
      // time = this.setOneMinutePlus(this.restaurantService.getWorkingPeriod(this.timetable, 'dinner').end);
      // this.restaurantService.setWorkingPeriod(this.timetable, 'dinner', null, time);
  }


  periodChanges() {
      if (this.period) {
          // this.pickedTimeBegin = this.restaurantService.getWorkingPeriod(this.timetable, this.period).begin;
          // this.pickedTimeEnd = this.restaurantService.getWorkingPeriod(this.timetable, this.period).end;
          //
          // if (this.period === 'lunch') {
          //     this.minTime = '00:00';
          //     this.maxTime = this.restaurantService.getWorkingPeriod(this.timetable, 'dinner').begin;
          // } else {
          //     this.minTime = this.restaurantService.getWorkingPeriod(this.timetable, 'lunch').end;
          //     this.maxTime = '00:00';
          // }
      }
  }

setDisableDinner() {
    if(this.disableDinner) {
        this.restaurant.dinnerDisabled = true;
    }
}

  setWorkingPeriod(interval: string, pickedTime: string) {
      this.interval = interval;

      const valid = this.isValid(pickedTime);

      // switch (valid) {
      //     case 'valid': {
      //         this.setPeriodParameters(pickedTime);
      //         this.timeError = 'valid';
      //         this.errorMessage = '';
      //         this.disableBegin = this.disableEnd = false;
      //         break;
      //     }
      //     case 'beginAfterEnd': {
      //         this.timeError = 'beginAfterEnd';
      //         this.errorMessage = this.ts.instant('component.setWorkPeriod.beginAfterEndMessage');
      //         this.disableBegin = false;
      //         this.disableEnd = true;
      //         break;
      //     }
      //     case 'endBeforeBegin': {
      //         this.timeError = 'endBeforeBegin';
      //         this.errorMessage = this.ts.instant('component.setWorkPeriod.endBeforeBeginMessage');
      //         this.disableBegin = true;
      //         this.disableEnd = false;
      //         break;
      //     }
      //     default: {
      //         this.timeError = 'defaultError';
      //         this.disableBegin = this.disableEnd = false;
      //         break;
      //     }
      // }
  }


  private setPeriodParameters(pickedTime: string) {
      // if (this.interval === 'beginInterval') {
      //     this.restaurantService.setWorkingPeriod(this.timetable, this.period, pickedTime, null);
      // } else {
      //     this.restaurantService.setWorkingPeriod(this.timetable, this.period, null, pickedTime);
      // }
  }


  private isValid(pickedTime: string) {
      // if (this.interval === 'beginInterval' && !this.isAfter(pickedTime,
      //   this.restaurantService.getWorkingPeriod(this.timetable, this.period).end)
      //     && !this.isAfter(pickedTime, this.pickedTimeEnd)) {
      //     return 'valid';
      // } else if (this.interval === 'endInterval' && this.isAfter(pickedTime,
      //   this.restaurantService.getWorkingPeriod(this.timetable, this.period).begin)
      //     && this.isAfter(pickedTime, this.pickedTimeBegin)) {
      //     return 'valid';
      // } else {
      //     if (this.interval === 'endInterval') {
      //         return 'endBeforeBegin';
      //     } else {
      //         return 'beginAfterEnd';
      //     }
      // }
  }


  private isAfter(time1: string, time2: string): boolean {
      const time1Array = time1.split(':');
      const time2Array = time2.split(':');

      if (+time1Array[0] < +time2Array[0]) {
          return false;
      } else {
          if (+time1Array[0] === +time2Array[0]) {
              if (+time1Array[1] < +time2Array[1]) {
                  return false;
              } else {
                  return true;
              }
          } else {
              return true;
          }
      }
  }


  private setOneMinutePlus(time: string): string {
      const splitTime = time.split(':');

      if (splitTime[1] === '59') {
          splitTime[0] = (+splitTime[0] + 1).toString();
          splitTime[1] = '00';
      } else {
          splitTime[1] = (+splitTime[1] + 1).toString();
      }

      time = (splitTime[0] + ':' + splitTime[1]);
      return time;
  }


  private setMinusOneMinute(time: string): string {
      const splitTime = time.split(':');

      if (splitTime[1] === '00') {
          splitTime[0] = (+splitTime[0] - 1).toString();
          splitTime[1] = '59';
      } else {
          splitTime[1] = (+splitTime[1]).toString();
      }

      time = (splitTime[0] + ':' + splitTime[1]);
      return time;
  }


  updateWorkingPeriod() {
      // this.setIntervalsForDB();
      // this.restaurant.timetable = this.timetable;
      // this.restaurantService.updateRestaurant(this.restaurant).then(() => {
      //     EatmaticStoreService.setRestaurant(this.restaurant);
      //     this.dismiss();
      //     this.showAlert(this.ts.instant('component.setWorkPeriod.title'), this.ts.instant('component.setWorkPeriod.success'));
      // }, error => {
      //     this.showAlert(this.ts.instant('component.setWorkPeriod.alertTitle'), this.ts.instant('component.setWorkPeriod.noSuccess'));
      // });
  }


  private setIntervalsForDB() {
      const checkValues = ['00', '15', '30', '45'];

      // this.timetable.forEach(period => {
      //     const end = period.end.split(':');
      //     if (checkValues.indexOf(end[1]) !== -1) {
      //         period.end = this.setMinusOneMinute(period.end);
      //     }
      // });

  }


  private showAlert(header: string, message: string) {
      const alert = this.alertCtlr.create({
          header,
          message,
          buttons: [
              {text: 'OK'}
          ]
      });
      alert.then(a => a.present());
  }


  dismiss() {
    this.viewCtrl.dismiss();
  }

}
